var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2",
    clipPath: "url(#clip0_109_114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Document"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33337 0C0.781089 0 0.333374 0.447715 0.333374 1V27C0.333374 27.5523 0.78109 28 1.33337 28H22.6667C23.219 28 23.6667 27.5523 23.6667 27V4.66667L19 0H1.33337Z",
    fill: "#E9F0FA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0001 0V4.66667H23.6667L19.0001 0Z",
    fill: "#C2CDDE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.3333,
    height: 28,
    fill: "white",
    transform: "translate(0.333374)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfbg);
export default __webpack_public_path__ + "static/media/pdfbg.f9d0009ab61dae858136d7ba6d0dc148.svg";
export { ForwardRef as ReactComponent };